import React from "react";
import Skeleton from "react-loading-skeleton";

function UIChatSkeleton() {
  return (
    <div style={{ marginTop: "20px" }}>
      <div className="date-text" style={{ textAlign: "center"}}>
        <Skeleton width={70} height={25} count={1} />
      </div>
      <div className="msgCreate" style={{ paddingLeft: 5 }}>
        <div style={{ display: "flex", minHeight: "50px" }}>
          <div className="profile-img" >
            <Skeleton circle width={32} height={32} count={1} />
          </div>
          <div className="msgStyle1">
            <Skeleton width={200} height={35} count={1} />
          </div>
          <div style={{ flex: 1, minWidth: "20%" }} />
        </div>
      </div>
      <div className="msgCreate" style={{ marginTop: "5px", paddingLeft: 5 }}>
        <div style={{ display: "flex", minHeight: "50px" }}>
          <div className="profile-img" >
            <Skeleton circle width={32} height={32} count={1} />
          </div>
          <div className="msgStyle1">
            <Skeleton width={230} height={35} count={1} />
          </div>
          <div style={{ flex: 1, minWidth: "20%" }} />
        </div>
        <div className="sentTimeStyle1">
          <Skeleton width={60} height={25} count={1} />
        </div>
      </div>
      <div
        className="msgCreate"
        style={{ marginTop: "10px", paddingRight: "14px" }}
      >
        <div className="msgSucc">
          <div
            className="btnGroupReSent"
            style={{ flex: "1 1 0%", minWidth: "20%", textAlign: "right" }}
          ></div>
          <div className="msgStyle2Skele" style={{ textAlign: "right"}}>
            <Skeleton width={250} height={35} count={1} />
          </div>
        </div>
        <div style={{ display: "flex", marginTop: "2px" }}>
          <div style={{ flex: 1, minWidth: "80%" }} />
          <Skeleton width={60} height={25} count={1} />
        </div>
      </div>
      <div className="date-text" style={{ textAlign: "center"}}>
        <Skeleton width={55} height={25} count={1} />
      </div>
      <div className="msgCreate" style={{ marginTop: "5px", paddingLeft: 5 }}>
        <div style={{ display: "flex", minHeight: "50px" }}>
          <div className="profile-img" >
            <Skeleton circle width={32} height={32} count={1} />
          </div>
          <div className="msgStyle1">
            <Skeleton width={230} height={35} count={1} />
          </div>
          <div style={{ flex: 1, minWidth: "20%" }} />
        </div>
        <div className="sentTimeStyle1">
          <Skeleton width={60} height={25} count={1} />
        </div>
      </div>
      <div
        className="msgCreate"
        style={{ marginTop: "10px", paddingRight: "14px" }}
      >
        <div className="msgSucc">
          <div
            className="btnGroupReSent"
            style={{ flex: "1 1 0%", minWidth: "20%", textAlign: "right" }}
          ></div>
          <div className="msgStyle2Skele" style={{ textAlign: "right"}}>
            <Skeleton width={100} height={35} count={1} />
          </div>
        </div>
        <div style={{ display: "flex", marginTop: "2px" }}>
          <div style={{ flex: 1, minWidth: "80%" }} />
          <Skeleton width={60} height={25} count={1} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(UIChatSkeleton);
